import React from 'react';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import StyledLoading from '../loading/StyledLoading';
import NewPaginationPerPage from '../pagination/NewPaginationPerPage';
import StyledText from '../styledComponents/StyledText';
import styled from 'styled-components';

const StyleLoadingRow = styled.tr`
  @keyframes placeHolderShimmer {
    0% {
      background: #ececec;
    }

    30% {
      background: #f7f7f7;
    }

    50% {
      background: #ececec;
    }

    80% {
      background: #f7f7f7;
    }

    100% {
      background: #ececec;
    }
  }
  td > div {
    animation: placeHolderShimmer 3s infinite;
    width: auto;
    height: 20px;
  }
`;

const Table = ({
  columns,
  sortColumn,
  onSort,
  data,
  hidePagination = false,
  loading,
  action,
  className,
  onRefetch,
  striped = false,
  highlightRowsOnHover = false,
  onRowClick,
  rowHighlighter,
  noDataFoundMessage = null,
  showContentLoader = false,
  isCatalogue,
  updatingTag,
  pointer = true,
  mainHeading,
  addOnPage,
  changeInPageNumber=false,
  websiteOrders=false
}) => {
  return (
    <>
      {!updatingTag && loading ? (
        <StyledLoading />
      ) : (
        <>
          <div className={`rounded ${className ? className : 'border'}`}>
            <table className="table mb-0 forum-table border-0">
              <TableHeader
              websiteOrders={websiteOrders}
                mainHeading={mainHeading}
                columns={columns}
                sortColumn={sortColumn}
                onSort={onSort && onSort}
                isCatalogue={isCatalogue}
              />
              {showContentLoader ? (
                <tbody>
                  <StyleLoadingRow>
                    {columns?.map((_, index) => (
                      <td key={index}>
                        {' '}
                        <div></div>{' '}
                      </td>
                    ))}
                  </StyleLoadingRow>
                </tbody>
              ) : (
                <TableBody
                websiteOrders={websiteOrders}
                  addOnPage={addOnPage}
                  columns={columns}
                  data={data?.content}
                  striped={striped}
                  rowHighlighter={rowHighlighter}
                  highlightRowsOnHover={highlightRowsOnHover}
                  onRowClick={onRowClick}
                  isCatalogue={isCatalogue}
                  pointer={pointer}
                />
              )}
            </table>
          </div>

          {noDataFoundMessage && !loading && (
            <StyledText
              $fontSize="18px"
              className="d-flex align-items-center justify-content-center my-3 my-md-3 py-1"
            >
              {noDataFoundMessage}
            </StyledText>
          )}
          {(!data || data?.length < 1) && !loading && (
            <StyledText
              as="h4"
              $fontSize="28px"
              className="d-flex align-items-center justify-content-center my-3 my-md-5"
            >
              No Data Found
            </StyledText>
          )}
          {!(!data || data?.length < 1 || hidePagination) && (
            <div className="p-2 p-md-4">
              <NewPaginationPerPage
                paginationData={data || {}}
                onPerPageChange={action?.handlePerPageChange}
                onPageChange={action?.handlePageChange}
                onRefetch={onRefetch}
                changeInPageNumber={changeInPageNumber}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Table;
